// Mock data para IllumiDev - Marketing Site

export const CONTACT_INFO = {
  email: 'illumi.dev@outlook.com',
  phone: '629.327.4788',
  phoneDisplay: '(629) 327-4788',
  consultationTime: '15-30',
  paymentMethods: ['PayPal', 'Venmo', 'Cash'],
  instagramHandle: 'illumi.dev',
  instagramUrl: 'https://instagram.com/illumi.dev'
};

export const BRAND = {
  name: 'IllumiDev',
  logoUrl: 'https://customer-assets.emergentagent.com/job_illumi-dev-preview/artifacts/gc0y7psl_IMG_5996.png',
  founderPhotoUrl: 'https://customer-assets.emergentagent.com/job_f98a51ab-08e6-4739-93b7-2cd2376bc8a7/artifacts/abe521m9_9FD695EB-107F-4163-BA43-728433F0CB31.png'
};

export const TAGLINES = {
  es: 'Construido para Crecer. Diseñado para Autoridad.',
  en: 'Built for Growth. Designed for Authority.'
};

export const HERO_SUBTITLES = {
  es: 'Especialista en desarrollo web premium que transforma negocios ambiciosos en líderes digitales autoridad a través de sitios web que convierten, automatizan y escalan.',
  en: 'Premium web development specialist transforming ambitious businesses into digital authority leaders through websites that convert, automate, and scale.'
};

export const TRUST_BADGES = {
  es: [
    {
      title: 'Entrega Rápida',
      description: 'Proyectos completados en tiempo récord'
    },
    {
      title: 'Soporte Bilingüe',
      description: 'Comunicación fluida en español e inglés'
    },
    {
      title: 'Cobertura Nacional',
      description: 'Servicio remoto en todo Estados Unidos'
    },
    {
      title: 'Enfoque en Automatización',
      description: 'Sistemas que trabajan mientras duermes'
    }
  ],
  en: [
    {
      title: 'Fast Delivery',
      description: 'Projects completed in record time'
    },
    {
      title: 'Bilingual Support',
      description: 'Fluent communication in Spanish and English'
    },
    {
      title: 'Nationwide',
      description: 'Remote service throughout the United States'
    },
    {
      title: 'Automation-Focused',
      description: 'Systems that work while you sleep'
    }
  ]
};

export const SERVICES = {
  es: [
    {
      title: 'Sitios Web Corporativos',
      description: 'Presencia digital premium que establece autoridad y genera confianza inmediata en tu audiencia.'
    },
    {
      title: 'E-commerce de Alto Rendimiento',
      description: 'Tiendas online optimizadas para conversión que convierten visitantes en clientes leales.'
    },
    {
      title: 'Automatización de Procesos',
      description: 'Sistemas inteligentes que eliminan tareas manuales y multiplican tu productividad.'
    },
    {
      title: 'Optimización y Mantenimiento',
      description: 'Monitoreo continuo y mejoras que mantienen tu sitio funcionando al máximo rendimiento.'
    }
  ],
  en: [
    {
      title: 'Corporate Websites',
      description: 'Premium digital presence that establishes authority and generates immediate trust in your audience.'
    },
    {
      title: 'High-Performance E-commerce',
      description: 'Conversion-optimized online stores that turn visitors into loyal customers.'
    },
    {
      title: 'Process Automation',
      description: 'Intelligent systems that eliminate manual tasks and multiply your productivity.'
    },
    {
      title: 'Optimization & Maintenance',
      description: 'Continuous monitoring and improvements that keep your site running at peak performance.'
    }
  ]
};

export const HOW_IT_WORKS = {
  es: [
    {
      number: '01',
      title: 'Consulta Estratégica',
      description: 'Analizo tus objetivos y diseño una estrategia personalizada para tu crecimiento digital.'
    },
    {
      number: '02',
      title: 'Desarrollo Premium',
      description: 'Construcción meticulosa usando las mejores prácticas y tecnologías más avanzadas.'
    },
    {
      number: '03',
      title: 'Optimización Continua',
      description: 'Refino cada detalle hasta lograr la máxima conversión y rendimiento.'
    },
    {
      number: '04',
      title: 'Lanzamiento y Escalado',
      description: 'Implementación estratégica con sistemas que crecen junto a tu negocio.'
    }
  ],
  en: [
    {
      number: '01',
      title: 'Strategic Consultation',
      description: 'I analyze your goals and design a personalized strategy for your digital growth.'
    },
    {
      number: '02',
      title: 'Premium Development',
      description: 'Meticulous construction using best practices and the most advanced technologies.'
    },
    {
      number: '03',
      title: 'Continuous Optimization',
      description: 'I refine every detail until achieving maximum conversion and performance.'
    },
    {
      number: '04',
      title: 'Launch & Scale',
      description: 'Strategic implementation with systems that grow alongside your business.'
    }
  ]
};

export const WHO_WE_WORK_WITH = {
  es: {
    title: 'Con Quién Trabajo',
    subtitle: 'Colaboro exclusivamente con negocios serios, enfocados en crecimiento a largo plazo y comprometidos con la excelencia.',
    clientTypes: [
      {
        title: 'Empresas en Crecimiento',
        description: 'Negocios establecidos listos para escalar digitalmente'
      },
      {
        title: 'Emprendedores Ambiciosos',
        description: 'Visionarios que buscan dominar su mercado online'
      },
      {
        title: 'Profesionales Premium',
        description: 'Expertos que necesitan una presencia digital de autoridad'
      }
    ]
  },
  en: {
    title: 'Who I Work With',
    subtitle: 'I collaborate exclusively with serious businesses, focused on long-term growth and committed to excellence.',
    clientTypes: [
      {
        title: 'Growing Companies',
        description: 'Established businesses ready to scale digitally'
      },
      {
        title: 'Ambitious Entrepreneurs',
        description: 'Visionaries looking to dominate their online market'
      },
      {
        title: 'Premium Professionals',
        description: 'Experts who need an authoritative digital presence'
      }
    ]
  }
};

export const CASE_STUDY = {
  es: {
    label: 'Caso Real',
    title: 'Transformación Digital Comprobada',
    headline: 'De Tienda Local a Presencia Nacional',
    description: 'Desarrollé un e-commerce completo para una boutique de ropa artesanal en Nashville. El desafío: su modelo solo funcionaba en persona. La solución: plataforma de ventas online con experiencia de compra premium, checkout simplificado, y sistema de emails automatizados. Resultado: en solo 3 meses comenzaron a recibir pedidos de 7 estados diferentes y recuperaron 31% de carritos abandonados gracias a la automatización inteligente.',
    metrics: [
      { number: '7', label: 'Estados' },
      { number: '31%', label: 'Recuperación' },
      { number: '3', label: 'Meses' }
    ]
  },
  en: {
    label: 'Real Case',
    title: 'Proven Digital Transformation',
    headline: 'From Local Store to National Presence',
    description: 'I developed a complete e-commerce solution for a handcrafted clothing boutique in Nashville. The challenge: their business model only worked in person. The solution: premium online sales platform with optimized shopping experience, simplified checkout, and automated email system. Result: in just 3 months they began receiving orders from 7 different states and recovered 31% of abandoned carts thanks to intelligent automation.',
    metrics: [
      { number: '7', label: 'States' },
      { number: '31%', label: 'Recovery' },
      { number: '3', label: 'Months' }
    ]
  }
};

export const VALUES = {
  es: [
    {
      title: 'Excelencia Sin Compromisos',
      description: 'Cada proyecto se desarrolla con los más altos estándares de calidad y atención al detalle.'
    },
    {
      title: 'Resultados Medibles',
      description: 'Me enfoco en métricas que importan: conversiones, crecimiento y ROI tangible.'
    },
    {
      title: 'Comunicación Transparente',
      description: 'Actualizaciones regulares, expectativas claras y colaboración genuina en cada paso.'
    }
  ],
  en: [
    {
      title: 'Excellence Without Compromise',
      description: 'Every project is developed with the highest standards of quality and attention to detail.'
    },
    {
      title: 'Measurable Results',
      description: 'I focus on metrics that matter: conversions, growth, and tangible ROI.'
    },
    {
      title: 'Transparent Communication',
      description: 'Regular updates, clear expectations, and genuine collaboration at every step.'
    }
  ]
};

export const PACKAGES = {
  es: [
    {
      name: 'Launch',
      price: '$499 – $900',
      description: 'Presencia digital profesional para emprendedores y pequeños negocios.',
      includes: [
        'Sitio web de 3–5 páginas',
        'Diseño responsive premium',
        'SEO básico + Google Business',
        'Formulario de contacto + CTA',
        'Analítica configurada',
      ],
      featured: false,
    },
    {
      name: 'Foundation',
      price: '$1,200 – $2,400',
      description: 'Sitio web completo con funcionalidades avanzadas y optimización para conversiones.',
      includes: [
        'Todo lo de Launch',
        'Hasta 10 páginas + blog',
        'CRM ligero + captura de leads',
        'Integración de email marketing',
        'Optimización de conversión (A/B)',
        '1 mes de soporte incluido',
      ],
      featured: true,
    },
    {
      name: 'Authority',
      price: '$2,800 – $5,000',
      description: 'Plataforma premium con automatización y sistemas de crecimiento integrados.',
      includes: [
        'Todo lo de Foundation',
        'Automatizaciones (Zapier / Make)',
        'AI Concierge chatbot',
        'Panel admin personalizado',
        'Integraciones (Stripe, Calendly, etc.)',
        '3 meses de soporte',
      ],
      featured: false,
    },
    {
      name: 'Infrastructure',
      price: '$5,500 – $12,000+',
      description: 'Solución empresarial completa con ecosistema digital totalmente personalizado.',
      includes: [
        'Todo lo de Authority',
        'Arquitectura full-stack a medida',
        'Multi-tenant / multi-idioma',
        'Sistema de intelligence de leads',
        'SLA + soporte prioritario',
        'Roadmap trimestral',
      ],
      featured: false,
    },
  ],
  en: [
    {
      name: 'Launch',
      price: '$499 – $900',
      description: 'Professional digital presence for entrepreneurs and small businesses.',
      includes: [
        '3–5 page website',
        'Premium responsive design',
        'Basic SEO + Google Business',
        'Contact form + primary CTA',
        'Analytics setup',
      ],
      featured: false,
    },
    {
      name: 'Foundation',
      price: '$1,200 – $2,400',
      description: 'Complete website with advanced functionality and conversion optimization.',
      includes: [
        'Everything in Launch',
        'Up to 10 pages + blog',
        'Lightweight CRM + lead capture',
        'Email marketing integration',
        'Conversion optimization (A/B tests)',
        '1 month of support included',
      ],
      featured: true,
    },
    {
      name: 'Authority',
      price: '$2,800 – $5,000',
      description: 'Premium platform with automation and integrated growth systems.',
      includes: [
        'Everything in Foundation',
        'Automations (Zapier / Make)',
        'AI Concierge chatbot',
        'Custom admin dashboard',
        'Integrations (Stripe, Calendly, etc.)',
        '3 months of support',
      ],
      featured: false,
    },
    {
      name: 'Infrastructure',
      price: '$5,500 – $12,000+',
      description: 'Complete enterprise solution with a fully customized digital ecosystem.',
      includes: [
        'Everything in Authority',
        'Bespoke full-stack architecture',
        'Multi-tenant / multi-language',
        'Lead intelligence system',
        'SLA + priority support',
        'Quarterly roadmap',
      ],
      featured: false,
    },
  ],
};

export const TESTIMONIALS = {
  es: [
    {
      text: 'La atención al detalle y la calidad del trabajo superaron completamente nuestras expectativas. Nuestro sitio web se convirtió en nuestra herramienta de ventas más poderosa.',
      author: 'María González',
      position: 'CEO, Luxury Boutique'
    },
    {
      text: 'Profesionalismo excepcional y resultados que hablan por sí solos. La automatización implementada nos ahorró 20+ horas semanales.',
      author: 'Carlos Mendoza',
      position: 'Fundador, Tech Startup'
    }
  ],
  en: [
    {
      text: 'The attention to detail and quality of work completely exceeded our expectations. Our website became our most powerful sales tool.',
      author: 'María González',
      position: 'CEO, Luxury Boutique'
    },
    {
      text: 'Exceptional professionalism and results that speak for themselves. The implemented automation saved us 20+ hours weekly.',
      author: 'Carlos Mendoza',
      position: 'Founder, Tech Startup'
    }
  ]
};

export const FAQ = {
  es: [
    {
      question: '¿Cuánto tiempo toma desarrollar un sitio web?',
      answer: 'Los tiempos varían según la complejidad: Launch (1-2 semanas), Foundation (2-4 semanas), Authority (4-6 semanas), Infrastructure (6-8 semanas).'
    },
    {
      question: '¿Qué incluye el soporte post-lanzamiento?',
      answer: 'Todos los paquetes incluyen 30 días de soporte gratuito, actualizaciones de seguridad, correcciones de errores y capacitación básica.'
    },
    {
      question: '¿Trabajas con empresas fuera de Estados Unidos?',
      answer: 'Sí, trabajo remotamente con clientes internacionales. La comunicación principal es en español e inglés.'
    },
    {
      question: '¿Qué métodos de pago aceptas?',
      answer: 'Acepto PayPal, Venmo y efectivo. Los proyectos se facturan por hitos con 50% inicial.'
    },
    {
      question: '¿Ofreces servicios de mantenimiento continuo?',
      answer: 'Sí, ofrezco planes de mantenimiento mensual que incluyen actualizaciones, backups, monitoreo de rendimiento y soporte prioritario.'
    },
    {
      question: '¿Qué pasa si no estoy satisfecho con el resultado?',
      answer: 'Trabajo por hitos con revisiones en cada fase. Si no cumple expectativas, refinamos hasta lograr tu satisfacción completa.'
    },
    {
      question: '¿Incluyes SEO en todos los proyectos?',
      answer: 'Sí, todos los sitios incluyen optimización SEO técnica básica. Los paquetes Authority e Infrastructure incluyen estrategia SEO avanzada.'
    },
    {
      question: '¿Puedo hacer cambios al sitio por mi cuenta después?',
      answer: 'Absolutamente. Incluyo capacitación personalizada y documentación detallada para que puedas gestionar contenido básico independientemente.'
    }
  ],
  en: [
    {
      question: 'How long does it take to develop a website?',
      answer: 'Timelines vary by complexity: Launch (1-2 weeks), Foundation (2-4 weeks), Authority (4-6 weeks), Infrastructure (6-8 weeks).'
    },
    {
      question: 'What does post-launch support include?',
      answer: 'All packages include 30 days of free support, security updates, bug fixes, and basic training.'
    },
    {
      question: 'Do you work with companies outside the United States?',
      answer: 'Yes, I work remotely with international clients. Primary communication is in Spanish and English.'
    },
    {
      question: 'What payment methods do you accept?',
      answer: 'I accept PayPal, Venmo, and cash. Projects are billed by milestones with 50% upfront.'
    },
    {
      question: 'Do you offer ongoing maintenance services?',
      answer: 'Yes, I offer monthly maintenance plans that include updates, backups, performance monitoring, and priority support.'
    },
    {
      question: "What if I'm not satisfied with the result?",
      answer: "I work by milestones with reviews at each phase. If it doesn't meet expectations, we refine until achieving your complete satisfaction."
    },
    {
      question: 'Do you include SEO in all projects?',
      answer: 'Yes, all sites include basic technical SEO optimization. Authority and Infrastructure packages include advanced SEO strategy.'
    },
    {
      question: 'Can I make changes to the site myself afterwards?',
      answer: 'Absolutely. I include personalized training and detailed documentation so you can manage basic content independently.'
    }
  ]
};

export const CLIENT_READINESS = {
  es: {
    title: '¿Estás Listo?',
    intro: 'Antes de agendar, verifica que cumples con estos criterios para una colaboración exitosa:',
    checklist: [
      'Tienes un presupuesto realista y aprobado para tu proyecto',
      'Buscas una solución a largo plazo, no un arreglo rápido',
      'Estás comprometido con el crecimiento y la excelencia digital',
      'Tienes tiempo para colaborar activamente en el proceso',
      'Valoras la calidad sobre el precio más bajo'
    ]
  },
  en: {
    title: 'Are You Ready?',
    intro: 'Before booking, verify that you meet these criteria for successful collaboration:',
    checklist: [
      'You have a realistic and approved budget for your project',
      'You seek a long-term solution, not a quick fix',
      'You are committed to growth and digital excellence',
      'You have time to actively collaborate in the process',
      'You value quality over the lowest price'
    ]
  }
};

export const IMAGES = {
  hero: 'https://images.unsplash.com/photo-1641998148499-cb6b55a3c0d3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjB3b3Jrc3BhY2V8ZW58MHx8fHwxNzczNTI2ODAyfDA&ixlib=rb-4.1.0&q=85',
  services1: 'https://images.unsplash.com/photo-1759661881353-5b9cc55e1cf4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBjb2Rpbmd8ZW58MHx8fHwxNzczNTI2ODE4fDA&ixlib=rb-4.1.0&q=85',
  services2: 'https://images.unsplash.com/photo-1760548425425-e42e77fa38f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjb2Rpbmd8ZW58MHx8fHwxNzczNTI2ODE4fDA&ixlib=rb-4.1.0&q=85',
  caseStudy: 'https://images.unsplash.com/photo-1615623705641-db34ad498cc5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHw0fHx3ZWJzaXRlJTIwbW9ja3VwJTIwZGVzaWduJTIwZWNvbW1lcmNlJTIwc2hvcHxlbnwwfHx8fDE3NzM1MzIwNjR8MA&ixlib=rb-4.1.0&q=85',
  tech: 'https://images.unsplash.com/photo-1760037034697-eee0b07ae072?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjB0ZWNofGVufDB8fHx8MTc3MzUyNjgzNnww&ixlib=rb-4.1.0&q=85'
};

// About section - will be editable from admin panel
export const ABOUT_DEFAULT = {
  es: {
    bio: 'Texto de biografía editable desde el panel de administración.',
    showInSite: false
  },
  en: {
    bio: 'Editable biography text from admin panel.',
    showInSite: false
  }
};
